import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-white mt-5 w-100">
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-md-4 text-center">
            <h5>Contact</h5>
            <p>
              Adresse : 3 rue des buissons
              <br />
              Ville : Saint-Jean-Rohrbach
              <br />
              Téléphone : 06 30 53 56 41
              <br />
              Email : batimentrs@yahoo.com
            </p>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col text-center">
            <h6>
              <p className="mb-0">
                <strong>
                  Batiment{" "}
                  <span
                    style={{
                      fontStyle: "italic",
                      color: "#0A6847",
                      fontSize: "20px",
                    }}
                  >
                    RS
                  </span>
                </strong>
              </p>
            </h6>
            &copy; 2024 Tous droits réservés.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
